import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import ArrowLeftIcon from '@/modules/Education/assets/icons/arrow-left.svg?react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import { EDUCATION_LINKS } from '../EducationLinks';
import { getEducationListQueryOptions } from '../queries/getEducationList/getEducationListQueryOptions';

import LoadingPage from '@/common/pages/LoadingPage';
import { EducationCardSize } from '../types/Education.type';
import EducationCard from './EducationCard';

export default function NewestEducation({
  cardSize,
}: {
  cardSize: EducationCardSize;
}) {
  const navigate = useNavigate();

  const { data, isPending } = useQuery(getEducationListQueryOptions());

  const handleViewAll = () => {
    navigate(EDUCATION_LINKS.educationList);
  };

  if (!isPending && (!data?.results || !data.results.length)) return;

  return (
    <Flex direction="column" w="100%" py={32} gap={16}>
      <Flex alignItems="center" justifyContent="space-between" w="100%">
        <Flex alignItems="center" gap={8}>
          <TitleDescription color="black-1" textStyle="h2">
            جدیدترین‌ آموزش ها
          </TitleDescription>
        </Flex>

        <Flex
          alignItems="center"
          gap={4}
          cursor="pointer"
          onClick={handleViewAll}
        >
          <Typography color="purple-primary" textStyle="b2">
            مشاهده همه
          </Typography>
          <ArrowLeftIcon />
        </Flex>
      </Flex>

      <Flex
        overflowX="auto"
        gap={16}
        w="100%"
        direction="row"
        pb={8}
        style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
        css={{
          '&::-webkit-scrollbar': { display: 'none' },
          '& > *': { flexShrink: 0 },
        }}
      >
        {isPending ? (
          <Box width="100%">
            <LoadingPage height="40vh" />
          </Box>
        ) : (
          data?.results
            ?.slice(0, 5)
            ?.map((item) => (
              <EducationCard key={item.id} {...item} cardSize={cardSize} />
            ))
        )}
      </Flex>
    </Flex>
  );
}
